<div class="instruccion">
    <h1 class="instruccion-texto">{{textoInstruccion}}</h1>
</div>

<ng-template #continente [ngIf]="opcionesSeleccion.length===1">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">Continente</li>
        </ol>
    </nav>
    <div class="container container-full">
        <div class="row">
            <ng-container *ngFor="let continente of opcionesSeleccion[0]">
                <div class="col col-lg-4 d-flex justify-content-center"
                    (click)="seleccionaContinente(true,continente.name)">
                    <div class="">
                        <img class="rounded-circle justify-content-center" src="{{continente.image}}"
                            alt="Generic placeholder image" width="140" height="140">
                        <h2 class="justify-content-center">{{continente.label}}</h2>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #pais [ngIf]="opcionesSeleccion.length===2">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a (click)="seleccionaContinente(false,continente.name)">Continente</a></li>
            <li class="breadcrumb-item active" aria-current="page">País</li>
        </ol>
    </nav>
    <div class="container container-full">
        <div class="row">
            <ng-container *ngFor="let pais of opcionesSeleccion[1]">
                <div class="col col-lg-4 d-flex justify-content-center" (click)="seleccionaPais(true,pais.name)">
                    <div class="">
                        <img class="rounded-circle justify-content-center" src="{{pais.image}}"
                            alt="Generic placeholder image" width="140" height="140">
                        <h2 class="justify-content-center">{{pais.label}}</h2>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #ciudad [ngIf]="opcionesSeleccion.length===3">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a (click)="seleccionaContinente(false,continente.name)">Continente</a></li>
            <li class="breadcrumb-item"><a (click)="seleccionaPais(false,pais.name)">País</a></li>
            <li class="breadcrumb-item active" aria-current="page">Ciudad</li>
        </ol>
    </nav>
    <div class="container container-full">
        <div class="row">
            <ng-container *ngFor="let ciudad of opcionesSeleccion[2]">
                <div class="col col-lg-4 d-flex justify-content-center" (click)="seleccionaCiudad(true,ciudad.name)">
                    <div class="">
                        <img class="rounded-circle justify-content-center" src="{{ciudad.image}}"
                            alt="Generic placeholder image" width="140" height="140">
                        <h2 class="justify-content-center">{{ciudad.label}}</h2>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #tour [ngIf]="opcionesSeleccion.length===4">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a (click)="seleccionaContinente(false,continente.name)">Continente</a></li>
            <li class="breadcrumb-item"><a (click)="seleccionaPais(false,pais.name)">País</a></li>
            <li class="breadcrumb-item"><a (click)="seleccionaCiudad(false,ciudad.name)">Ciudad</a></li>
            <li class="breadcrumb-item active" aria-current="page">Tour</li>
        </ol>
    </nav>
    <div class="album py-5 bg-light">
        <div class="container container-full">
            <!-- <div class="col col-lg-4 d-flex justify-content-center" routerLink='/tour/{{tour.id}}'>                
                <div class="">
                    <img class="rounded-circle justify-content-center" src="{{tour.image}}" alt="Generic placeholder image"
                        width="140" height="140">
                    <h2 class="justify-content-center">{{tour.name}}</h2>
                </div>
            </div> -->
            <div class="row">
                <ng-container *ngFor="let tour of opcionesSeleccion[3]">
                    <div class="col-md-4">
                        <div class="card mb-4 box-shadow">
                            <!-- <img class="card-img-top" src="{{tour.image}}" alt="Imagen del tour"> -->
                            <img *ngIf="tour.imageSanitizer != null" class="card-img-top" [src]="tour.imageSanitizer"
                                alt="Imagen del tour" style="height: 125px; object-fit: cover;">
                            <img *ngIf="tour.imageSanitizer == null" class="card-img-top" src="assets/no-image.png"
                                alt="Imagen del tour sin image" style="height: 125px; object-fit: cover;">
                            <div class="card-body" style="height: 200px;">
                                <h2 class="justify-content-center truncate" style="font-size: 1em;">{{tour.name}}</h2>
                                <p class="card-text truncate-description" style="height: 75px; font-size: 0.8rem">
                                    {{tour.description}}</p>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                            routerLink='/tour/{{tour.id}}/vista'>Ver</button>
                                    </div>
                                    <!-- <small class="text-muted">9 mins</small> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>